// Brazil
export const locale = {
    lang: 'pt-br',
    data: {
        TRANSLATOR: {
            SELECT: 'Selecione seu Idioma',
            ENTITY: 'Entidade',
        },
        DATEPICKER: {
            IntervalOfDates: 'Intervalo de Datas',
            Initial: 'Inicio',
            End: 'Fim',
            Year: 'Ano',
            Month: 'Mês',
            Day: 'Dia',
            Select: 'Selecione',
        },
        ACTION: {
            Cancel: 'Cancelar',
            Back: 'Voltar',
            Confirm: 'Confirmar',
            Clear: 'Limpar',
            Export: 'Exportar',
            Filter: 'Filtrar',
            Search: 'Pesquisar',
        },
        MENU: {
            NEW: 'Novo',
            ACTIONS: 'Comportamento',
            CASHIER: 'Caixa',
            CREATE_POST: 'Criar ',
            PAGES: 'Páginas',
            FEATURES: 'Caracteristicas',
            APPS: 'Aplicações',
            DASHBOARD: 'Painel de Controle',
            ACCOUNTRECEIVING: 'Contas a Receber',
            FILERETURN: 'Arquivos de Retorno',
            COLLECTORFILE: 'Arquivo de Cobradoras',
            MANAGE: 'Gerenciar',
            IMPORT: 'Importar',
            BACKPREVIOUSMENU: 'Voltar para o menu anterior',
            FILEREMITANCE: 'Arquivos de Remessa',
            FILEGENERATE: 'Gerar Arquivo',
            TOOLS: 'Ferramentas',
            ROUNDING: 'Arredondamento',
            MANAGEMENT: 'Administrativo',
            CHANGECONTRACT: 'Alteração Contrato',
            RECORDSCARD: 'Registro de Cartões',
            CREDITCARDRECURRENCE: 'Recorrências Cartão de Credito',
            RECURRINGCARD: 'Cartão Recorrente',
            RECURRENCEMANAGEMENT: 'Gerenciamento de Recorrência',
            MANAGETASKS: 'Gerenciar Tarefas',
            FINANCIAL: 'Financeiro',
            DEVELOPMENT: 'Desenvolvimento',
            MANAGEBUGS: 'Gerenciar os Erros',
            DUE_DATE_IN_BATCHES: 'Data de Vencimento em Lotes',
            BILLET: 'Boleto',
            REPORT: 'Relatório',
            FATURATION: 'Faturação',
            BACK: 'Voltar',
            MappingCurrentAccountBillet: 'Mapeamento de Boletos',
            ACCOUNTING: 'Contábil',
            ACCOUNTING_BATCH: 'Lote Contábil',
            RECEIVING: 'Recebimento',
            RECEIVINGS: 'Recebimentos',
            PIX: 'PIX',
        },
        CUSTOMLIST: {
            FILEMANAGE: {
                COLUNS: {
                    fileName: 'Nome do Arquivo',
                    date: 'Data',
                    quantityLines: 'Qtd. de Linhas',
                    processStatus: 'Status',
                    processStatusString: 'Status',
                    agreementCode: 'Convênio',
                    collectorCode: 'Cobradora',
                    valueTotal: 'Valor á creditar',
                },
                VALUES: {
                    StandBy: 'Aguardando Processamento',
                    Processing: 'Processando',
                    Pendency: 'Pendência',
                    Accounted: 'Contabilizado',
                    Failed: 'Falha',
                    Succeeded: 'Processado',
                },
            },
            FILEAUDIT: {
                COLUNS: {
                    creditDate: 'Data de Pagamento',
                    valuePaid: 'Valor Pago',
                    numberLine: 'Item',
                    error: 'Pendência',
                    listPossibleSolutions: 'Solução',
                    billetNumber: 'Nº Fatura',
                    billetDueDate: 'Vencimento',
                    billetValue: 'Valor',
                    statusReturn: 'Status Retorno',
                    lineStatusString: 'Status da Linha',
                    difference: 'Diferença ℹ️',
                    action: 'Ações',
                    info: 'Informações',
                    returnDate: 'Data de Retorno',
                    lineStatus: 'Status da Linha',
                    legalEntityDescription: 'Escola',
                    beneficiaryName: 'Aluno',
                    lateFeesValue: 'Multas',
                    interestValue: 'Juros',
                    honorarioValue: 'Honorarios',
                },
                VALUES: {
                    '4 - PayAnotherBilletWithDifference': '4 - Pagar outro boleto com a diferença',
                    '8 - SolutionByAccounting': '8 - Gerar Devolução',
                    '1 - AcceptDifference': '1 - Aceitar a diferença',
                    '5 - LeaveBilletWithlargerPayment': '5 - Aceitar diferença a maior',
                    '2 - ExemptDifferenceInterestFees': '2 - Isentar Juros/Multa',
                    '3 - LeaveBilletWithPartialPay': '3 - Realizar pagamento parcial',
                    '9 - NotSulution': '9 - Sem solução manual',
                    '10 - AcceptCollector': '10 - Aceitar Recebimento Cobradora',
                    PayAnotherBilletWithDifference: 'Pagar outro boleto com a diferença',
                    SolutionByAccounting: 'Gerar Devolução',
                    AcceptDifference: 'Aceitar a diferença',
                    AcceptCollector: 'Aceitar Recebimento Cobradora',
                    LeaveBilletWithlargerPayment: 'Aceitar diferença a maior',
                    ExemptDifferenceInterestFees: 'Isentar Juros/Multa',
                    LeaveBilletWithPartialPay: 'Realizar pagamento parcial',
                    NotSulution: 'Sem solução manual',
                    StandBy: 'Aguardando Processamento',
                    Schedule: 'Pronto para Processar',
                    Enqueued: 'Na Fila',
                    Processing: 'Processando',
                    Pendency: 'Pendência',
                    WrittenOff: 'Baixado',
                    Confirmed: 'Confirmado',
                    Rejected: 'Rejeitado',
                    Succeeded: 'Concluído',
                    Others: 'Outros',
                    ExpirationOfTerm: 'Decurso de Prazo',
                    Failed: 'Falha',
                    BilletCanceled: 'Boleto cancelado',
                    BilletNotExist: 'Boleto não encontrado',
                    BilletPaid: 'Boleto pago',
                    ValueLessWithoutFees: 'Valor menor sem considerar taxas',
                    ValueLessWithFees: 'Valor menor considerando taxas',
                    ValueGreater: 'Valor a mais',
                    ConditionalDiscountDifference: 'Diferença de desconto condicional',
                    BilletCollector: 'Boleto em Cobradora',
                    BilletNegotiation: 'Boleto em Negociação',
                },
            },
            CONTRACTS: {
                COLUNS: {
                    description: 'Descrição do Contrato',
                    date: 'Data',
                    period: 'Periodo',
                },
            },
        },
        STATUS: {
            All: 'Todos',
            Add: 'Adicionar',
            Alter: 'Alterar',
            Cancel: 'Cancelar',
            WritOff: 'Deletar',
        },
        CardRecurrence: 'Cartão Recorrente',
        NoRecurrence: 'Sem Recorrencia',
        Scheduled: 'Agendado',
        Confirmed: 'Confirmado',
        Error: 'Erro',
        Processing: 'Processando',
        RetirementPending: 'Pendente de Baixa',
        NoneFinancialAgreement: 'Nenhum Convênio Financeiro',
        Unauthorized: 'Não autorizado',
        NoCapture: 'Sem Captura',
        All: 'Todos',
        SELECT: {},
        ENUM: {
            NoRecurrence: 'Sem Recorrencia',
            Scheduled: 'Agendado',
            Confirmed: 'Confirmado',
            Error: 'Erro',
            Processing: 'Processando',
            RetirementPending: 'Pendente de Baixa',
            NoneFinancialAgreement: 'Nenhum Convênio Financeiro',
            Unauthorized: 'Não autorizado',
            NoCapture: 'Sem Captura',
            All: 'Todos',
            Opened: 'Aberto',
            Closed: 'Fechado',
            Accounted: 'Contabilizado',
        },
        MESSAGES: {
            HOMEMESSAGE:
                'Estamos preparando novos conteúdos para você. Enquanto isso você pode navegar em outras telas através do menu na lateral esquerda',
            WELCOME: 'Bem vindo',
        },
        CASHIERMANAGEMENT: {
            dateOpen: 'Data de Abertura',
            dateClose: 'Data de Fechamento',
            user: 'Usuário',
            numberCasher: 'Número da Caixa',
            entity: 'Entidade',
            statusCashier: 'Status da Caixa',
            clear: 'Limpar',
            filter: 'Filtrar',
            export: 'Exportar',
            thereIsNoDataToLoad: 'Não existem dados a serem carregados',
            deposit: 'Depósito',
            deposit2: 'Depositar',
            accountsBank: 'Contas Bancárias',
            accountBank: 'Conta Bancária',
            depositDate: 'Data do Depósito',
            value: 'Valor',
            add: 'Adicionar',
            date: 'Data',
            thereIsNoDepositAdded: 'Não há nenhum depósito adicionado',
            amountToDeposit: 'Valor a Depositar',
            depositedAmount: 'Valor Depositado',
            missingValue: 'Valor Faltante',
            cancel: 'Cancelar',
            start: 'Início',
            final: 'Fim',
            opening_interval: 'Intervalo de Abertura',
            apply: 'Aplicar',
            payment: 'Pagamento',
            receipt: 'Recebimento',
            toDeposit: 'A Depositar',
            accounted: 'Contabilizado',
            transfer_of_cashier: 'Transferência de Caixa',
            transfer: 'Transferir',
            transfer_cashier: 'Transferir Caixa',
            search: 'Pesquisar',
            print: 'Imprimir',
            cashier: 'Caixa',
            are_you_sure_you_want_to_transfer_cashier_to_this_selected_cashier:
                'Tem certeza que deseja transferir o caixa para esse caixa selecionado?',
            please_select_cashier: 'Por favor, selecione um caixa',
            cashier_transferred: 'Caixa Transferido',
        },
        BILLET: {
            start: 'Início',
            final: 'Fim',
            cancel: 'Cancelar',
            apply: 'Aplicar',
            due_date_range: 'Período de Vencimento',
            period: 'Período',
            service: 'Serviço',
            clear: 'Limpar',
            search: 'Pesquisar',
            thereIsNoDataToLoad: 'Não existem dados a serem carregados',
            contract: 'Contrato',
            student: 'Aluno',
            number: 'Número',
            dueDate: 'Data de Vencimento',
            value: 'Valor',
            alter: 'Alterar',
            filters: 'Filtros',
            changes: 'Alterações',
            new_due_date: 'Nova Data de Vencimento',
            alter_all: 'Alterar Todos',
            alter_selecteds: 'Alterar Selecionados',
            due_date_in_batches: 'Data de Vencimento em Lotes',
            confirmation_of_alteration: 'Confirmação de Alteração',
            are_you_sure_you_want_to_change_expiration_date: 'Tem certeza que deseja alterar a data de vencimento',
            of_all_filtered_bills: 'de todos os boletos filtrados',
            of_the_selected_bills: 'dos boletos selecionados',
            expiration_date_successfully_changed: 'Data de Vencimento alterada com sucesso',
            registered: 'Registrado',
            discounts_will_accompany_change: 'Descontos acompanharão alteração',
            discount: 'Desconto',
            wait_for_processing: 'Aguarde o processamento',
        },
        GENERAL: {
            yes: 'Sim',
            no: 'Não',
        },
        FILEGENERATE: {
            dueDate: 'Data de Vencimento',
            billetNumber: 'N° Fatura',
            billetCode: 'Código do Boleto',
            ourNumber: 'Nosso Numero',
            responsible: 'Responsável',
            beneficiary: 'Beneficiário',
            value: 'Valor',
            dateRequested: 'Data Requisição',
            status: 'Tipo de Alteração',
        },
        FILEMANAGEMENT: {
            fileName: 'Nome do Arquivo',
            fileNumber: 'N° do Arquivo',
            createDate: 'Data de Criação',
            agreementCode: 'Código do Convênio',
            bankName: 'Banco',
            totalValue: 'Valor do Arquivo',
            quantityLines: 'N° de Linhas',
        },
        STATUSRETURNLINE: {
            standby: 'Em Espera',
            sheduled: 'Agendado',
            enqueued: 'Enfileirado',
            awaiting: 'Aguardando',
            proccessing: 'Processando',
            success: 'Concluído',
            failed: 'Falha',
            deleted: 'Excluído',
            accounted: 'Contabilizado',
            pendency: 'Pendência',
            all: 'Todos',
        },
        AUDITRETURNFILE: {
            delete_with_successful: 'Item excluído com sucesso!',
            items_with_valores_duplicates: 'Existem itens com valores duplicados. Por favor remova um.',
            error_to_delete: 'Erro ao excluir!',
        },
        JournalType: {
            All: 'Todos',
            AccountsPayable: 'Contas a Pagar',
            Provision: 'Provisionamento',
            AnticipatedRevenue: 'Receita Antecipada',
            Receiving: 'Recebimento',
            Payment: 'Pagamento',
            Remittance: 'Remessa',
            CheckTransit: 'Cheque',
            Imported: 'Importado',
            Uncollectible: 'Incobrável',
            CardTransit: 'Cartão',
            Payment_Cashier: 'Pagamento/Caixa',
            Receiving_Cashier: 'Recebimento/Caixa',
            Receiving_WebPayment: 'Recebimento/Pagamento Web',
            Pix: 'Pix',
            Receiving_Pix: 'Recebimento/Pix',
            Receiving_Migration: 'Recebimento/Migração',
            Receiving_EarlyReceiving: 'Recebimento/Recebimento Antecipado',
            Receiving_RecurringCard: 'Recebimento/Recorrente cartão',
            Remittance_Cashier: 'Remessa/Caixa',
            Receiving_Bank: 'Recebimento/Banco',
            Deposit_Cashier: 'Depósito/Caixa',
        },
        JournalStatus: {
            All: 'Todos',
            0: 'Exportar',
            None: 'Nenhum',
            Awaiting: 'Aguardando',
            Success: 'Exportado',
            CreationError: 'Erro na Criação',
            ExportError: 'Erro na exportação',
        },
        JournalErrors: {
            AccountAreaIsRequired: 'A área da conta é obrigatória',
            AccountChartNotFound: 'Plano de contas não encontrado',
            AccountCodeIsRequired: 'O código da conta é obrigatório',
            AccountCodeMustBeUnique: 'O código da conta deve ser único',
            AccountDuplicatesFound: 'Conta duplicada encontrada',
            accounting_type_not_configured: 'Tipo de Contabilização não configurado',
            AccountingMonthEntityIsNotTheSameAsAccountingEntity:
                'A Entidade do Mês Contábil não é a mesma que a Entidade Contábil',
            AccountingMonthNotFound: 'Mês contábil não encontrado',
            AccountingMonthShouldBeOpen: 'O mês contábil deve estar aberto',
            AccountNameIsRequired: 'O nome da conta é obrigatório',
            AccountNameMustBeUnique: 'O nome da conta deve ser único',
            AccountNotFound: 'Conta não encontrada',
            AccountPlanNotFound: 'Plano de conta não encontrado',
            AccountsMustContainEntityArea: 'As contas devem conter a área da entidade',
            AccountsNotFound: 'Contas não encontradas: {{detail}}',
            AddingFunctionsRequireAnAccountingEntity: 'Funções de Adição requerem uma Entidade Contábil',
            AllAccountsMustAcceptEntries: 'Todas as contas devem aceitar entradas',
            AllAccountsMustBelongToTheSameEntityAndFactDate:
                'Nem todas as contas pertencem ao plano de contas da entidade',
            AllFunctionsMustAcceptEntries: 'Nem todos os departamentos aceitam lançamentos',
            AllFunctionsMustHaveConfiguration: 'Nem todos os departamentos possuem configuração',
            AllFunctionsMustHaveTheSameEntity: 'Nem todos departamentos pertencem á entidade',
            AllFundsMustAcceptEntries: 'Nem todos os fundos permitem lançamentos',
            AllFundsMustHaveConfiguration: 'Nem todos os fundos devem estão configurados',
            AllFundsMustHaveTheSameEntity: 'Nem todos os fundos devem são da mesma entidade',
            AllItemsShouldBeAccountedBeforeClosing: 'Todos os itens devem ser contabilizados antes do fechamento',
            AllSubaccountsMustHaveTheSameEntity: 'Todas as subcontas devem possuir a mesma entidade',
            AllEntriesMustHaveTheSpecifiedFund: 'Todos os lançamentos possuem o fundo especificado',
            AossIdIsRequired: ' O identificador AOSS é obrigatório',
            AreaCodeMustBeUnique: 'O código da area deve ser único',
            AtLeastOneAccountIsRequired: 'Pelo menos uma conta é necessária',
            AtLeastTwoItemsMustBeSupplied: 'Pelo menos dois itens devem ser fornecidos',
            classification_not_found: 'Classificação não encontrada',
            CodeIsRequired: 'O código é obrigatório',
            config_item_required: 'Item da Categoria é obrigatório',
            configuration_already_exists: 'Configuração já existe',
            DescriptionIsRequired: 'A descrição é obrigatória',
            DuplicateAccountingMonthFor: 'Mês contábil duplicado para  {{detail}}',
            EntityCannotBeChanged: 'Entidade não pode ser editada',
            EntityCodeIsRequired: 'O código da entidade é obrigatório',
            EntityConfigurationAlreadyExists: 'A configuração da entidade já existe',
            EntityConfigurationCannotBeNull: 'A Configuração da entidade não pode ser nula',
            EntityConfigurationIsRequired: 'A configuração da entidade é necessária',
            EntityconfigurationNotFound: 'Configuração de entidade não encontrada',
            EntityConnectionNotFound: 'Conexão de entidade não encontrada',
            EntityMonthLimitReached: 'Limite de mês contábil da entidade atingido',
            EntityNameIsRequired: 'O nome da entidade é obrigatório',
            EntityNotFound: 'Entidade não encontrada',
            EntityNotSupplied: 'Entidade não suportada',
            EntityShouldBeAnAccountingEntity: 'A entidade não é uma entidade contábil',
            FinalDateIsRequired: 'Data Final é obrigatória',
            FixedTypeOnlySupportsOneAccount: 'O tipo fixo suporta apenas uma conta',
            FunctionAlreadyBelongsToEntity: 'O departamento já pertence à entidade',
            FunctionCodeIsRequired: 'O código do departamento é obrigatório',
            FunctionCodeMustBeUnique: 'O código do departamento deve ser único',
            FunctionNameIsRequired: 'O nome do departamento é obrigatório',
            FunctionNotFound: 'Departamento não encontrado',
            FunctionParentNotFound: 'Departamento pai não encontrada',
            FunctionsNotFound: 'Departamentos não encontrados: {{detail}}',
            FunctionsShouldBelongToTheSameEntity: 'Departamentos devem pertencer à mesma entidade',
            FundCannotBeNull: 'Os fundos não podem ser nulos',
            FundCodeIsRequired: 'O código do fundo é obrigatório',
            FundCodeMustBeUnique: 'O código do fundo deve ser único',
            FundNameIsRequired: 'O nome do fundo é obrigatório',
            FundNotFound: 'Fundo não encontrado',
            FundsCanOnlyBeAddedToAnAccountingEntity: 'Os fundos só podem ser adicionados a uma Entidade Contábil',
            FundsNotFound: 'Fundos não encontrados: {{detail}}',
            FundsShouldBelongToTheSameEntity: 'Os fundos devem pertencer à mesma entidade',
            inactive_entity: 'A entidade selecionada está inativa',
            InitialDateIsRequired: 'Data Inicial é obrigatória',
            InitialDateShouldBeLowerThanFinalDate: 'Data Inicial deve ser menor que a Data Final',
            invalid_base_rule: 'Regra base Inválida',
            invalid_configuration: 'Configuração Inválida',
            invalid_definition: 'Definição Inválida',
            invalid_entity: 'Entidade Inválida',
            InvalidAccountingMonth: 'Mês Contábil inválido',
            InvalidDescriptionFor: 'Descrição inválida para: {{detail}}',
            InvalidName: 'Nome Inválido',
            InvalidParent: 'Pai inválido',
            ItemSumMustBeEqualsToZero: 'A soma do item deve ser igual a zero',
            ItemsWithotSubaccountTypesCannotHaveSubaccounts: 'Os itens sem tipos de subconta não podem ter subcontas',
            ItIsNotPossibleToCreateACanceledLedger: 'Não é possível criar uma razão cancelada',
            KindShouldBeCorD: "Tipo deve ser 'C' ou 'D'",
            LedgerAlreadyReversed: 'Razão já invertida',
            LedgerCanOnlyBeChangedIfNotAccounted:
                'O lançamento não pode ser alterado pois está em um lote verificado/contabilizado',
            LedgerMustBeAccounted: 'A razão deve ser contabilizada',
            LedgerNotFound: 'Razão não encontrada',
            LotEntityAndAccountingMonthEntityDoesNotMatch:
                'Entidade do lote e entidade do mês contábil não correspondem',
            MaxMonthsOpenMustBeGreaterThan: 'O número máximo de meses em aberto deve ser maior que zero',
            MustBeAccountingEntity: 'É necessária uma entidade contábil',
            NameIsRequired: 'O nome é obrigatório',
            NameMustBeUnique: 'O nome deve ser único',
            NoItemsFoundForLedger: 'Nenhum lançamento encontrado',
            YouCannotDeleteBecauseBatchChecked: 'Não é possível excluir lançamentos pois o lote já foi verificado',
            NonStandardFunctionsShouldOnlyHaveOneEntity: 'Funções não padrão devem ter apenas uma entidade',
            NumberIsRequired: 'O número é obrigatório',
            OneAccountIsRequired: 'É necessária pelo menos uma conta',
            OneOrMoreFunctitonsNotFound: 'Uma ou mais funções não encontradas',
            OneOrMoreFundsNotFound: 'Um ou mais fundos não encontrados',
            ParentAccountMustBeDifferent: 'A conta principal deve ser diferente',
            ParentAccountNotFound: 'Conta principal não encontrada',
            ParentAccountNotFoundOnAccountPlan: 'Conta pai não encontrada no plano de contas',
            ParentNotFound: 'Pai não encontrado',
            PeriodAndPlanEntitiesDoNotMatch: 'Período e plano de entidade não correspondem',
            PeriodNotFound: 'Período não encontrado',
            PersonMustHavePrimaryDocument: 'A pessoa deve possuir um documento primário.',
            RestrictionCodeMustBeUnique: 'O código de restrição deve ser único',
            SubAccountCodeCannotBeNullOrEmpty: 'O código da subconta não pode ser nulo ou vazio',
            SubAccountNameCannotBeNullOrEmpty: 'O nome da subconta não pode ser nulo ou vazio',
            SubaccountNotFound: 'Subconta não encontrada',
            SubAccountIsRequired: 'Subconta é obrigatória para a conta selecionada.',
            SubaccountTypeDoesNotMatchAccount: 'O tipo de subconta não corresponde à conta',
            SubaccountTypeNotFound: 'Tipo de subconta não encontrado',
            TheCodeMustBeUniqueForTheEntity: 'O código deve ser único para a entidade',
            TheFundIsAlreadyAssociatedWithThisEntity: 'O fundo já está associado a esta entidade',
            ThereIsAnotherEntityPlanForTheSamePeriod: 'Existe outro plano de entidade para o mesmo período',
            ThisShouldntBeInvokedInNonDevelopmentEnvironments:
                'Isso não deve ser chamado em ambientes de não desenvolvimento',
            TypeIsRequired: 'O tipo é obrigatório',
            UsernameIsRequired: 'Nome de usuário é necessário',
            UsernameMustBeIncluded: 'O nome de usuário deve ser incluído',
            InvalidFactDate: 'A data do fato é inválida',
            NotPossibel: 'Não é possível realizar a operação',
            AccountingMonthDateError: 'O mês contábil não pode ser aplicado para a data do fato indicada',
            ProvisionHasNotBeenAccounted: 'Não é possível marcar como pronto pois a provisão não foi contabilizada',
            JustificationNotSupplied: 'Justificativa não informada',
            NotPossible: 'Não é possível realizar a operação',
            LotDependencies: 'O lote possui dependências',
            AllItemsReversed: 'Todos os itens do lote já foram estornados',
            NoLedgersFound: 'Nenhum Lançamento Encontrado',
            OpenAccountingMonthNotFound: 'Nenhum mês contábil aberto foi encontrado',
        },
        Data: 'Data',
        'Batch Type': 'Tipo de Lote',
        Itens: 'Itens',
        Mês: 'Mês',
        Ano: 'Ano',
        Número: 'Número',
        'Nome de Usuário': 'Nome de Usuário',
        Status: 'Status',
        'Cod. Escola': 'Cod. Escola',
        Aluno: 'Aluno',
        Responsável: 'Responsável',
        Parcela: 'Parcela',
        Bandeira: 'Bandeira',
        'Nº Cartão': 'Nº Cartão',
        Valor: 'Valor',
        Vencimento: 'Vencimento',
        ReturnCode: 'Código de Retorno',
    },
};
